module.exports = __webpack_public_path__ + "static/img/default_program_hor.779bcaa8.jpg";